<template>
    <div>
      <div v-if="this.$store.state.showSwiper"  class="MySwiper-wrapper">
        <div class="bg"></div>
        <MySwiper class="MySwiper"></MySwiper>
      </div>
      <div>
        <Search></Search>
        <NongliCalendar></NongliCalendar>
        <div>
          <Itm></Itm>
        </div>

        <loading v-if="this.$store.state.LOADING"/>
        <nodata v-if="this.$store.state.NODATA"/>
      </div>
      <div>
        <WxShare></WxShare>
      </div>
    </div>
</template>

<script>

  import WxShare from '@/components/WxShare';
  import Search from '@/components/Search';
  // import MyCalendar from '@/components/MyCalendar';
  import Itm from '@/components/Itm';
  import loading from '@/components/loading';
  import nodata from '@/components/nodata';
  import NongliCalendar from '@/components/NongliCalendar';
  import MySwiper from './MySwiper';
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created() {
    // this.$store.commit('setChooseDay','2020/12/01')
  },
  components: {
    MySwiper,
    WxShare,
    // MyCalendar,
    Search,
    Itm,
    loading,
    nodata,
    NongliCalendar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
<style lang="less" scoped>
  .MySwiper-wrapper{
    .bg{
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: black;
      opacity: .7;
      z-index: 3;
    }
    .MySwiper{
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      color: black;
      z-index: 3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue